import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import "./CustomCursor.css";
import { useLocation } from 'react-router-dom';

const CustomCursor = () => {
  const location = useLocation();
  const cursorRef = useRef(null);
  const dotRef = useRef(null);
  const [label, setLabel] = useState("View");
  const [isTouch] = useState(() => window.matchMedia("(hover: none)").matches);

  useEffect(() => {
    if (isTouch) return;
    
    const cursor = cursorRef.current;
    const dot = dotRef.current;

    document.body.style.cursor = "none";

    const onMouseMove = (e) => {
      gsap.to(cursor, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.5,
        ease: "power3.out",
      });
      gsap.to(dot, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.1,
        ease: "none",
      });
    };

    const isInteractive = (el) => {
      if (el.closest("[data-cursor-none]")) return null;
      return el.closest("a, button, .project-card, [data-cursor]");
    };

  const onMouseOver = (e) => {
    const target = isInteractive(e.target);
    if (!target) return;

    const cursorLabel = target.dataset.cursor;
    if (cursorLabel) setLabel(cursorLabel);
    else setLabel("View");

    gsap.to(cursor, { scale: 1, opacity: 1, duration: 0.3, ease: "power3.out" });
    gsap.to(dot, { scale: 0, duration: 0.3, ease: "power3.out" });
  };

  const onMouseOut = (e) => {
    const target = isInteractive(e.target);
    if (!target) return;

    if (target.contains(e.relatedTarget)) return;

    gsap.to(cursor, { scale: 0, opacity: 0, duration: 0.3, ease: "power3.out" });
    gsap.to(dot, { scale: 1, duration: 0.3, ease: "power3.out" });
  };

    window.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseover", onMouseOver);
    document.addEventListener("mouseout", onMouseOut);

    return () => {
      document.body.style.cursor = "auto";
      window.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseover", onMouseOver);
      document.removeEventListener("mouseout", onMouseOut);
    };
  }, [isTouch]);

  useEffect(() => {
    if (!cursorRef.current || !dotRef.current) return;
    gsap.to(cursorRef.current, { scale: 0, opacity: 0, duration: 0.3, ease: "power3.out" });
    gsap.to(dotRef.current, { scale: 1, duration: 0.3, ease: "power3.out" });
  }, [location.pathname]);

  if (isTouch) return null;

  return (
    <>
      <div className="custom-cursor" ref={cursorRef}>
        <span className="cursor-label">{label}</span>
      </div>
      <div className="cursor-dot" ref={dotRef} />
    </>
  );
};

export default CustomCursor;